import script from "./main-header.vue?vue&type=script&setup=true&lang=ts"
export * from "./main-header.vue?vue&type=script&setup=true&lang=ts"

import "./main-header.vue?vue&type=style&index=0&id=7b979d59&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b979d59"]])

export default __exports__